export default __webpack_public_path__ + "static/media/nft-example-2.2d9f0208.jpg";